export default __webpack_public_path__ + "static/media/School_1.e9f1972a.jpg";